import { render, staticRenderFns } from "./vLogoDefault.vue?vue&type=template&id=1d88cfcb&scoped=true"
import script from "./vLogoDefault.vue?vue&type=script&lang=js"
export * from "./vLogoDefault.vue?vue&type=script&lang=js"
import style0 from "./vLogoDefault.vue?vue&type=style&index=0&id=1d88cfcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d88cfcb",
  null
  
)

export default component.exports